import '../../vendor/jquery.vimeo.api'
import '../../vendor/player'

export default {
    init() {

        if ($(".module-toggle-video")[0]) {
            var old_src = "0";
            var src = "1";
            const audio = new Audio("https://freesound.org/data/previews/501/501690_1661766-lq.mp3");

            var toggleVideo1 = $("#video1");
            var toggleVideoPlayer1 = new Vimeo.Player(toggleVideo1);

            var toggleVideo2 = $("#video2");
            var toggleVideoPlayer2 = new Vimeo.Player(toggleVideo2);

            var toggleVideo3 = $("#video3");
            var toggleVideoPlayer3 = new Vimeo.Player(toggleVideo3);

            $(document).ready(function() {
                // Mettre toute les vidéos en pause au chargement de la page
                $('.module-toggle-video iframe').each(function(i, obj) {
                    var player = new Vimeo.Player(obj);

                    player.pause();
                });

                // Jouer la première vidéo au chargement de la page
                toggleVideoPlayer1.play();

                // Affiche image fixe à la fin de la dernière vidéo.
                toggleVideoPlayer3.on('ended', function() {
                    $(".module-toggle-video #fixe").css("display", "block");
                    $(".module-toggle-video .scroll").css("display", "block");

                    audio.play();
                });
            })

            /* Affiche un input slider 10 secondes avant la fin de la video 2 */
            var duration_vid2 = 0;
            var running_time = 0;

            function revealSlider() {
                toggleVideoPlayer2.getDuration().then((data) => duration_vid2 = data);

                var refreshIntervalId = window.setInterval(function() {
                    toggleVideo2.vimeo("getCurrentTime", function(data) {

                        running_time = data;

                        if (running_time > duration_vid2 - 10 && running_time < duration_vid2 - 9) {
                            $(".module-toggle-video .changeVideo2").css({ "display": "block" });
                            clearInterval(refreshIntervalId);
                        }
                    })
                }, 100);
            }

            /* Transition entre vidéos lorsque l'on change l'input slider */
            window.changeVideo = function(obj) {
                $(".module-toggle-video #fixe").css("display", "none");
                var value = obj.value;

                if ($(obj).hasClass("changeVideo1")) {
                    // Fait disparaître le premier input slider au changement entre la vidéo 1 et 2
                    $(".module-toggle-video .changeVideo1").css({ "display": "none" });

                    revealSlider();
                } else {
                    // Fait disparaître le deuxieme input slider au changement entre la vidéo 2 et 3
                    $(".module-toggle-video .changeVideo2").css({ "display": "none" });

                    value = (parseInt(value) + 1);
                }

                var elem = ".module-toggle-video #video" + (parseInt(value) + 1);
                var old_elem = ".module-toggle-video #video" + (parseInt(old_src) + 1);

                src = parseInt(value) + 1;
                old_src = value;


                var old_player = new Vimeo.Player($(old_elem));

                old_player.pause();

                var player = new Vimeo.Player($(elem));

                player.play();

                $(elem).addClass('transitioning-src');

                setTimeout(function() {
                    $(old_elem).removeClass('transitioning-src');
                }, 500);
            }

            /* Fonction permettant de mettre en mute la vidéo de toggle en cours de lecture et de l'unmute */
            window.muteToggleVideo = function() {
                $('.module-toggle-video iframe').each(function(i, obj) {
                    var player = new Vimeo.Player(obj);
                    player.getVolume().then(function(volume) {
                        // volume = the volume level of the player
                        if (volume == 1) {
                            player.setVolume(0);
                            $(".module-toggle-video #song").text("Muted");
                            audio.muted = true;

                        } else {
                            player.setVolume(1);
                            $(".module-toggle-video #song").text("Unmuted");
                            audio.muted = false;
                        }
                    })
                });
            }

            // Animation des petits points pour la flèche scroll
            var animation = gsap.timeline({ repeat: -1, yoyo: true });

            animation.to(".module-toggle-video .dot", { duration: 1, opacity: 1, stagger: 0.1 }, 0);
        }
    }
}